<template>
  <v-container>
    <v-row no-gutters class="mb-6" align="center">
      <v-col><h2>Gallery photos</h2></v-col>
      <v-col cols="auto"
        ><v-btn
          text
          :color="$buttonColor"
          outlined
          class="create-poll"
          small
          @click="refresh()"
        >
          <v-icon size="small" class="mr-1">fas fa-redo</v-icon>
          Refresh
        </v-btn></v-col
      >
    </v-row>
    <div v-if="images == null || images.length == 0">
      <v-row class="ma-0" align="center" justify="center">
        <v-icon class="mx-auto" color="#E1E2E6" size="200px">mdi-image</v-icon>
      </v-row>
      <v-row class="ma-0" align="center" justify="center">
        <div class="font-weight-bold no-data">ไม่มีรูปภาพให้แสดง</div>
      </v-row>
    </div>
    <v-row v-if="images !== null && images.length>0">
      <v-col
        v-for="(image, index) in images"
        :key="index"
        class="d-flex child-flex col_grid_image"
        cols="12"
        lg="3"
        md="3"
        sm="4"
        xs="12"
      >
        <v-card flat tile class="d-flex">
          <v-img
            :src="image.url"
            aspect-ratio="1"
            class="grey lighten-2 zoom"
            @click="zoomImage(image.url)"
            style="margin-left: 25px; border-style: solid; border-width: thin; margin-bottom: 25px;"
          ></v-img>
        </v-card>
      </v-col>

      <v-dialog
        width="100%"
        max-width="800px"
        v-model="dialog_zoom"
        overlay-opacity="0.6"
        overlay-color="black"
      >
        <v-img :src="selectedImage">
          <div class="close-btn">
            <v-btn icon class="close-dialog" @click="dialog_zoom = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-img>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  // props: {
  //   images: {
  //     type: Array
  //   }
  // },
  data() {
    return {
      // images: [],
      dialog_zoom: false,
      selectedImage: ""
    };
  },
  computed: {
    images() {
      return this.$store.getters.liveImages;
    }
  },
  // async mounted() {
  //   this.images = this.$store.state.liveImages
  // },
  methods: {
    openNewWeb(url) {
      window.open(
        url,
        "vuetifyjs",
        "resizable,scrollbars,status,width=1000,height=700"
      );
    },
    zoomImage(src) {
      this.dialog_zoom = true;
      this.selectedImage = src;
    },
    refresh(){
      const payload = {
        idcourse: this.$store.state.hCourseId,
        idlivestream: this.$store.state.hLiveId,
      };
      this.$store.dispatch("fetchLImage", {payload});
    }
  }
};
</script>
<style scoped>
/* .live-image-card{
  width: 100%;
  padding-bottom: 40%;
  padding-top: 40%;

  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}
.live-image-card:hover{
  transform: scale(1.15, 1.15);
  cursor: pointer;
} */
.zoom {
  cursor: zoom-in;
}
.no-data {
  color: #e1e2e6;
}
.col_grid_image {
  padding: 2px !important;
}
.toolbar_zoom {
  float: right;
  background-color: transparent !important;
  border-radius: 100%;
  border-top-left-radius: inherit !important;
  border-top-right-radius: inherit !important;
  border-bottom-left-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.col_zoom {
  align-items: center;
  margin: 0px !important;
  padding: unset;
  border: unset;
}
/* .stylee_dialog_zoom {
  box-shadow: unset;
} */
.row_zoom {
  margin: unset;
}
.btn_zoom {
  color: white !important;
}
.description {
  font-size: 16px;
}
.chat-avatar {
  padding: 10px 10px 10px 0px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.box-disable {
  background-color: #f4f4f4;
  vertical-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  /* width: 60%; */
  /* border: 3px solid #73AD21; */
  padding: 6px;
}
.white-text-btn {
  color: white;
}
.close-dialog {
  float: right;
  margin-right: 10px;
}
@media only screen and (max-width: 960px) {
  .cardImg {
    height: 300px;
    width: 300px;
  }
}
@media only screen and (min-width: 961px) {
  .cardImg {
    height: 800px;
    width: 800px;
  }
}
.create-poll {
  background: initial !important;
  font-size: inherit !important;
  border-color: initial !important;
  border-radius: 4px !important;
}
</style>